import { Component, Inject, Vue } from 'vue-property-decorator';
import PersonalBecaService from '@/entities/seguimiento/personal-beca.service';
import PermisosUsuarioSnp, { PantallaSnp } from '@/entities/snp/permisos/permisos-snp.factory';
import { IPersonalBeca, PersonalBeca } from '@/shared/model/seguimiento/personal-beca.model';
import { Area } from '@/shared/model/enumerations/area';

@Component
export default class PermisosSnpMixin extends Vue {
  @Inject('personalBecaService') protected readonly personalBecaService!: () => PersonalBecaService;

  public tienePermisosDeVisualizar = false;
  public personalBeca: IPersonalBeca = new PersonalBeca();

  public validarPermisosSnp(pantalla: PantallaSnp): void {
    return this.validarPermisosEspecialSnp(pantalla, null);
  }

  /**
   * Consulta los permisos de usuario para visualizar componetes VUE.
   * Generalmnete son pantallas completas.
   * Pueden ser funcionalidades dentro de una pantalla.
   * Asigna el permiso con un boolean en la variable 'tienePermisosDeVisualizar'
   * Se invoca en el Hook create().
   *
   * @see Definición webapp/app/entities/snp/permisos/permisos-snp.factory.ts
   * @param pantalla Nombre de la Pantalla o sección visual
   * @param personalBeca objeto personal becas a validar desde el exterior
   * @returns void
   */
  public validarPermisosEspecialSnp(pantalla: PantallaSnp, personalBeca: PersonalBeca | null): void {
    if (!!personalBeca) {
      this.personalBeca = personalBeca;
      this.tienePermisosDeVisualizar = PermisosUsuarioSnp.validarPermisos(pantalla, personalBeca.rol);
      return;
    }

    this.obtenerRolSnp()
      .then(personalBeca => {
        this.personalBeca = personalBeca;
        this.tienePermisosDeVisualizar = PermisosUsuarioSnp.validarPermisos(pantalla, personalBeca.rol);
      })
      .catch(() => (this.tienePermisosDeVisualizar = false));
  }

  public obtenerRolSnp(): Promise<IPersonalBeca> {
    return new Promise((resolve, reject) => {
      this.personalBecaService()
        .find(true, Area.POSGRADOS)
        .then(res => resolve(res))
        .catch(err => reject(new Error(err)));
    });
  }
}
